import { Controller } from "stimulus"

export default class extends Controller {
  onPostSuccess(event){
    $('#review-reply-modal').remove();
    $('#add-reply-modal').html(event.detail[2].response);
    $('#review-reply-modal').modal();
  }
}
